<template>
  <div class="nsale_ myPage_ teamM_">
    <div class="form_">
      <div class="input_">
        <div class="text_">账号名称：</div>
        <div class="inputStyle inputStyle2">
          {{ form.name | filterNull }}
        </div>
      </div>
      <div class="input_">
        <div class="text_">账号：</div>
        <div class="inputStyle inputStyle2">
          {{ form.loginName | filterNull }}
        </div>
      </div>
      <div class="input_">
        <div class="text_">手机号码：</div>
        <div class="inputStyle inputStyle2">
          {{ form.phone | filterNull }}
        </div>
      </div>
      <div class="input_">
        <div class="text_">是否投保：</div>
        <div class="inputStyle inputStyle2">
          {{ form.policyNum > 0 ? '是' : '否' }}
        </div>
      </div>
      <div class="input_">
        <div class="text_">保单数量：</div>
        <div class="inputStyle inputStyle2">
          {{ form.policyNum || 0 }}个
        </div>
      </div>
    </div>

    <cube-button class="btn_" @click="goback">返回</cube-button>
  </div>
</template>

<script>
import api from "@/utils/api";
import moment from "moment";
const column1 = [{ text: "禁用", value: "1" }, { text: "启用", value: "2" }];
export default {
  data() {
    return {
      id: "",
      edit: false,
      form: {
        // id: "720101",
        // name: "user001",
        // loginName: "user001",
        // linkman: "张三1",
        // contactInformation: "13654754524",
        // phone: "13566666666",
        // password: null,
        // teamTemplateId: null,
        // teamTemplateName: "00990",
        // accountType: null,
        // netFeeType: null,
        // settleType: null,
        // forbiddenType: "0",
        // authenticationFlag: "1",
        // searchChars: null,
        // creator: null,
        // createDate: 1583203644000,
        // ids: null,
        // params: null,
        // imageUrl: null,
        // referrer: null,
        policyNum: 0
      }
    };
  },
  beforeRouteEnter(to, from, next) {
    console.log("beforeRouteEnter -->", to, from);
    next();
  },
  activated() {
    console.log("activated -> ", 1, this.$route);
  },
  //   beforeRouteLeave(to, from, next) {
  //     console.log("beforeRouteLeave -->", to, from, next);
  //     next();
  //   },
  filters: {
    filterNull(val) {
      if (val == "" || val == null) {
        return "无";
      } else {
        return val;
      }
    }
  },
  mounted() {
    this.hideOptionMenu();
    this.id = this.$route.params.id;
    this.edit = this.$route.meta.edit;
    this.getDetail();
  },
  methods: {
    hideOptionMenu() {
      try {
        WeixinJSBridge.call("hideOptionMenu");
      } catch (error) {}
    },
    getDetail() {
      api.getUserDetailByUserId(this.id).then(res => {
        this.form = res.data.content;
      });
    },
    showToast(text) {
      this.$createToast({
        txt: text,
        time: 1000,
        type: "txt"
      }).show();
    },
    goback() {
      this.$router.go(-1);
    }
  }
};
</script>

<style scoped lang="scss">
.nsale_ {
  font-family: PingFang SC;
  background: rgba(245, 245, 245, 1);
  min-height: 100vh;
}
.btn_ {
  width: 305px;
  height: 50px;
  background: rgba(255, 74, 53, 1);
  border-radius: 5px;
  margin: 10px auto;
}
.cancel {
  font-size: 15px;
  color: rgba(255, 74, 53, 1);
  margin: 0 auto;
}
.form_ {
  padding: 0px 35px;
  background: #fff;
  .i_img {
    height: 7px;
    width: auto;
  }
  .input_ {
    width: 305px;
    height: 60px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    border-bottom: 1px solid #f7f7f7;
    .text_ {
      font-size: 15px;
      color: rgba(51, 51, 51, 1);
      width: 100px;
      text-align: left;
      height: 40px;
      line-height: 17px;
      display: flex;
      align-items: center;
    }

    .inputStyle {
      font-size: 15px;
      color: #cccccc;
      height: 36px;
      width: 192px;
      display: flex;
      justify-content: flex-end;
      align-items: center;
      text-align: left;
    }
    .inputStyle1 {
      height: 94px;
      width: 285px;
    }
    .inputStyle2 {
      font-size: 15px;
      color: rgba(51, 51, 51, 1);
    }
  }
  .red_ {
    color: #ff4a35 !important;
  }
  .green_ {
    color: #00be28 !important;
  }
}
</style>
